import { routerMiddleware } from 'connected-react-router';
import { createHashHistory, History } from 'history';
import { applyMiddleware, compose, legacy_createStore as createStore, Middleware, Store } from 'redux';
import { createLogger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';

import rootEpic from './rootEpic';
import createRootReducer, { AppState } from './rootReducer';

export const history: History = createHashHistory({
  hashType: 'slash',
});

export function configureStore(): Store {
  const epicMiddleware = createEpicMiddleware();
  const logger = createLogger({
    collapsed: true,
    diff: true,
  });

  const isProduction = process.env.NODE_ENV === 'production';

  const plainMapper: Middleware = () => next => action => next(Object.assign({}, action));

  const middlewareEnhancer = isProduction
    ? applyMiddleware(plainMapper, epicMiddleware, routerMiddleware(history))
    : applyMiddleware(plainMapper, epicMiddleware, routerMiddleware(history), logger as unknown as Middleware);

  const store: Store<AppState> = createStore(createRootReducer(history), compose(middlewareEnhancer));

  epicMiddleware.run(rootEpic);

  return store;
}
